import { useContext } from "react";
import { AppStatusContext } from "./appStatusContextCore";
import type { AppStatusContextValue } from "./appStatusTypes";

export function useAppStatus(): AppStatusContextValue {
  const value = useContext(AppStatusContext);
  if (!value) {
    throw new Error("useAppStatus muss innerhalb von AppStatusProvider verwendet werden.");
  }
  return value;
}
